module.exports = __webpack_public_path__ + "img/Metastasis-CRC_10X_TGSP.e5630b5e.png";